/* RESPONSIBLE TEAM: team-proactive-support */
import Model, { attr } from '@ember-data/model';

export default class AssigneeEmail extends Model {
  @attr('number') assigneeId;
  @attr('string') email;
  @attr('string') localPart;
}
